module.exports = __webpack_public_path__ + "img/18_newYouth_phc.f871c7ff.png";